import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import DurationInput from "../../../../Input/DurationInput";
import { jsx as _jsx } from "react/jsx-runtime";
function DurationInputCell(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/_jsx(DurationInput, _extends({}, props));
}
export default DurationInputCell;